export const fairCreditReportingActDisclosureStatement = (name?: string, ssn?: string, date?: string) => {
  return [
    { text: 'Fair Credit Reporting Act Disclosure Statement', style: 'h1' },
    {
      text: 'In accordance with the provisions of Section 604 (b)(2)(A) of the Fair Credit Reporting Act, Public Law 91-508, as amended by the Consumer Credit Reporting Act of 1996 (Title II, Subtitle D, Chapter I, of Public Law 104-208), you are being informed that reports verifying your previous employment, previous drug and alcohol test results, and your driving record may be obtained on you for employment purposes. These reports are required by Section 382.413 and 391.25 of the Federal Motor Carrier Safety Regulations.',
      style: 'p',
    },
    {
      canvas: [
        {
          type: 'line',
          x1: 0,
          y1: 0,
          x2: 200,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
        {
          type: 'line',
          x1: 500,
          y1: 0,
          x2: 350,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
      ],
      style: 'input',
    },

    { text: "Driver's Signature", style: 'label', margin: [0, -2, 0, 0] },
    { text: `${date}`, margin: [350, -32, 0, 0] },
    { text: "Date", style: 'label', margin: [350, 5, 0, 0] },

    {
      canvas: [
        {
          type: 'line',
          x1: 0,
          y1: 20,
          x2: 200,
          y2: 20,
          lineWidth: 1,
          lineColor: 'black',
        },
        {
          type: 'line',
          x1: 500,
          y1: 20,
          x2: 350,
          y2: 20,
          lineWidth: 1,
          lineColor: 'black',
        },
      ],
      style: 'input',
    },

    { text: `${name}`, margin: [0, -22, 0, 0] },
    { text: "Print Name", style: 'label', margin: [0, 5, 0, 0] },
    { text: `${ssn}`, margin: [350, -32, 0, 0] },
    { text: "Social Security Number", style: 'label', margin: [350, 5, 0, 0] },

    { text: '', pageBreak: 'before' },
  ];
};